/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { getIsHotelOnly } from 'src/store/view/selectors';
import Searcher from '../Searcher';
import SearcherResults from '../../components/SearcherResults';
import SearcherOperators from '../SearcherOperators';

import styles from './searcherContainer.module.css';

const SearcherContainer = ({ isHotelOnly, isMobile, ...props }) => (
  <div
    className={classnames({
      [styles.containerMobile]: isMobile,
    })}
    {...props}
  >
    <Searcher />
    {!isHotelOnly && <SearcherOperators />}
    <SearcherResults />
  </div>
);

const mapStateToProps = (state) => ({
  isHotelOnly: getIsHotelOnly(state),
});

export default connect(mapStateToProps)(SearcherContainer);
